import { WidgetsAddressEditMain } from '@/widgets/address-edit';

export const PagesAddressEditMain = () => <WidgetsAddressEditMain />;
